











































































import Vue, { PropType } from "vue"
import RowGroup from "~/components/guideline/util/RowGroup.vue"
import ColumnWithIcon from "~/components/guideline/util/ColumnWithIcon.vue"
import {
  CORPORATION_ICON,
  CALENDAR_ICON,
  BUSINESS_ICON,
  PEOPLE_ICON,
  DESCRIPTION_ICON,
  LINK_ICON,
} from "~/config/icon"
import { UserProfileExperienceProjectView } from "~/backendApis/viewModel/userProfileSearch"

export default Vue.extend({
  components: {
    RowGroup,
    ColumnWithIcon,
  },
  props: {
    project: {
      type: Object as PropType<UserProfileExperienceProjectView>,
      required: true,
    },
    isDetailExpanded: {
      type: Boolean,
      default: false,
    },
    isMultipleCareers: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      icon: {
        corporation: CORPORATION_ICON,
        calendar: CALENDAR_ICON,
        business: BUSINESS_ICON,
        people: PEOPLE_ICON,
        description: DESCRIPTION_ICON,
        link: LINK_ICON,
      },
    }
  },
})
